module.exports = __webpack_public_path__ + "img/spinner-icon.4b74bf00.svg";